import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import DetalleFueraDeGradoView from '../../components/listados/DetalleFueraDeGradoView'
import { obtenerDetalleFueraDeGrado } from '../../actions/listados'

function DetalleDescargaPorGrado (props) {
  const { detalle, obtenerDetalleFueraDeGrado, fechaDesde, fechaHasta } = props

  useEffect(() => {
    obtenerDetalleFueraDeGrado(fechaDesde, fechaHasta, detalle.exportador, detalle.cereal, detalle.cerealVariedad)
  }, [obtenerDetalleFueraDeGrado, detalle, fechaDesde, fechaHasta])

  return (
    <DetalleFueraDeGradoView />
  )
}

const mapActionsToProps = {
  obtenerDetalleFueraDeGrado
}

const mapStateToProps = (state) => ({
  fechaDesde: state.stock.fechaDPorGrado,
  fechaHasta: state.stock.fechaHPorGrado
})

const withRedux = connect(mapStateToProps, mapActionsToProps)
export default withRedux(DetalleDescargaPorGrado)
